import React from 'react';
export function NewTopBar() {
  return <div className="bg-forest-deep text-white py-2 px-4 text-center text-xs sm:text-sm font-bold tracking-wider uppercase" data-id="element-334">
      ⚠️ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
    </div>;
}